class ReportLogDto {
  constructor(data) {
    if (data.id == null) throw new Error("id is required");
    if (data.user == null) throw new Error("user is required");
    if (data.organizationId == null) throw new Error("organizationId is required");
    if (data.reportId == null) throw new Error("reportId is required");
    if (data.dateOfLog == null) throw new Error("dateOfLog is required");

    this.id = data.id;
    this.user = data.user;
    this.organizationId = data.organizationId;
    this.reportId = data.reportId;
    this.logContent = data.logContent;
    this.dateOfLog = data.dateOfLog;
  }

  static createDefaultLogItem = (
    organizationId,
    reportId,
    date
  ) => new ReportLogDto({
    id: 0,
    user: {
      userName: '',
      type: 0,
      id: 0,
    },
    organizationId: organizationId,
    reportId: reportId,
    logContent: 'Melding aangemaakt',
    dateOfLog: date,
  });

  static createPlaceholderLogItem = () => new ReportLogDto({
    id: 0,
    dashboardUserId: 0,
    user: {
      type: 0,
      userName: 'User',
    },
    dashboardUserName: '',
    organizationId: -1,
    reportId: -1,
    logContent: 'Placeholder log-content voor de visuele placeholder.',
    dateOfLog: 'Placeholder datum',
  });
}

export default ReportLogDto;